import { lazy, Suspense, useState, useCallback } from 'react';

const ReceiptPopup = lazy(() => import('@components/checkListV2/Modals/ReceiptPopup'));

const useReceipt = ({ checkData, serverAppTheme }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const jsx = isOpen ? (
    <Suspense fallback={null}>
      <ReceiptPopup
        row={checkData}
        onClose={close}
        serverAppTheme={serverAppTheme}
      />
    </Suspense>
  ) : null;

  return { open, jsx };
};

export default useReceipt;
